module.exports = __webpack_public_path__ + "static/3-2d33d6c5631076708b08116d0c67716b.jpg";